function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11 14.667a3.334 3.334 0 110-6.668 3.334 3.334 0 010 6.668",
  stroke: "#008af5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.667 8.449v-3.23c0-.354-.141-.693-.391-.943l-1.885-1.885C10.14 2.14 9.8 2 9.448 2H3.333C2.597 2 2 2.597 2 3.333v9.334C2 13.403 2.597 14 3.333 14h5.673",
  stroke: "#008af5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.667 5.333H10a.667.667 0 01-.667-.666V2M10.92 10.21v1.301l1.025.625",
  stroke: "#008af5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));